import PropTypes from 'prop-types';
export const promoBarPropTypes = {
  text: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  counter: PropTypes.shape({
    visible: PropTypes.bool,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    text: PropTypes.string
  }),
  link: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string
  }),
  variant: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string
};